/**
 * Where each card starts when the map changes view (PathwayNodeLayer's
 * `glideKey`): a card that was on screen starts where it was; a card that
 * appears starts where its nearest visible ancestor was and fades in, so a
 * chain grows out of the milestone or town it hangs from.
 *
 * @param {Array<{id, parentId?, parent_id?}>} nodes  the cards drawn now
 * @param {Record<string, {x, y}>} positions          where they end
 * @param {Record<string, {x, y}>} prev               where the last view had its cards
 * @returns {Record<string, {x, y, fresh: boolean}>}
 */
export function glideStarts(nodes, positions, prev) {
  const byId = new Map(nodes.map((n) => [n.id, n]));
  const parentOf = (id) => {
    const n = byId.get(id);
    return n ? (n.parentId || n.parent_id || null) : null;
  };
  const starts = {};
  for (const n of nodes) {
    if (prev[n.id]) { starts[n.id] = { ...prev[n.id], fresh: false }; continue; }
    const seen = new Set([n.id]);
    let p = parentOf(n.id);
    while (p && !prev[p] && !seen.has(p)) { seen.add(p); p = parentOf(p); }
    const from = (p && prev[p]) || positions[n.id];
    if (from) starts[n.id] = { x: from.x, y: from.y, fresh: true };
  }
  return starts;
}
